import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance, _DocumentAffiliate } from "../../../core/services/dataBean/EntityCatalogVdos";
import { DocumentTemplateEditor } from "../../bpm/config/DocumentTemplateEditor";
import { DocumentTRDEditor } from "../../bpm/config/DocumentTRDEditor";
import { SelectRecurso } from "../../Factoty&Production/LabourType/SelectRecurso";
import { DocEditor } from "./DocEditor";
import { ListPropsTypePayroll } from "./ListPropsTypePayroll";
import { ListPropsLoanLine } from "./ListPropsLoanLine";





export const DocumentAffiliate = () => {

    const DocumentAffiliate = useDataBean(_DocumentAffiliate);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [])


    const getLista = () => {

        DocumentAffiliate.instance.getDocumentAffiliateCatalogPorPropiedades({ State: 1 }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }



    const create = () => {
        DocumentAffiliate.setBean({
            State: 1,
            RoleSubmit: 100,
            IDEmployee: single.getAccountID()
            // Since: single.getCurrenDate()
        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        DocumentAffiliate.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        DocumentAffiliate.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDDocumentAffiliate', visible: true },
        { title: 'Nombre Documento', property: 'DocumenName', visible: true },
        { title: 'Rol de carga', property: 'RoleSubmit', visible: false },
        { title: 'Fecha', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Documentos Requisito">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={DocumentAffiliate.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Documento</label>
                                    <DocEditor render={DocumentAffiliate.bean.DocumenName} idSelector={DocumentAffiliate.bean.IDHiringModalityDocument} onChange={(e) => { DocumentAffiliate.setBean({ ...DocumentAffiliate.bean, "IDHiringModalityDocument": e.IDHiringModalityDocument, "DocumenName": e.Name }) }} label=" " returnType="Object" />
                                </div>
                                <div className="col-md-6">
                                    <label>Quien Carga</label>
                                    <select className="form-select" name="RoleSubmit" value={DocumentAffiliate.bean.RoleSubmit} onChange={DocumentAffiliate.handleChange}>
                                        <option value={100}>Solicitante o Funcionario</option>
                                        <option value={101}>Solicitante</option>
                                        <option value={102}>Funcionario</option>
                                    </select>
                                </div>

                                <div className="col-md-12">
                                    <fieldset className="p-2">
                                        <ListPropsTypePayroll jsonProps={DocumentAffiliate.bean.JSONPayRollEntity} onChange={(e) => { DocumentAffiliate.setBean({ ...DocumentAffiliate.bean, JSONPayRollEntity: e }) }} />
                                    </fieldset>
                                </div>

                                <div className="col-md-12">
                                    <fieldset className="p-2">
                                        <ListPropsLoanLine jsonProps={DocumentAffiliate.bean.JSONLoanLine} onChange={(e) => { DocumentAffiliate.setBean({ ...DocumentAffiliate.bean, JSONLoanLine: e }) }} />
                                    </fieldset>
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}